import styled from 'styled-components'

export const Wrapper = styled.div`
  white-space: pre-wrap;
  overflow-wrap: break-word;

  a {
    color: var(--blue) !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

Wrapper.displayName = 'Wrapper'
